var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55357 10.52C3.41369 10.3831 3.33333 10.1985 3.33333 10.0021C3.33333 9.80569 3.41369 9.62117 3.55357 9.48426L8.79166 4.48426C9.07738 4.21045 9.52976 4.22236 9.80059 4.50807C10.0714 4.79379 10.0625 5.24617 9.77678 5.517L5.83035 9.28784H15.9524C16.3482 9.28784 16.6667 9.60629 16.6667 10.0021C16.6667 10.398 16.3482 10.7164 15.9524 10.7164H5.83035L9.77976 14.4843C10.0655 14.7581 10.0744 15.2075 9.80357 15.4932C9.53273 15.7789 9.08035 15.7878 8.79464 15.517L3.55654 10.517L3.55357 10.52Z",
    fill: "#2E3285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.01038918d7d96cd8768acb7149d34528.svg";
export { ForwardRef as ReactComponent };